{
  "CONTACT_PANEL": {
    "CONFIRM": {
      "YES": "OK",
      "CANCEL": "Mégse"
    },
    "NOT_AVAILABLE": "Nem elérhető",
    "EMAIL_ADDRESS": "Email cím",
    "PHONE_NUMBER": "Telefonszám",
    "WHATSAPP_USERNAME": "WhatsApp felhasználónév",
    "IDENTIFIER": "Azonosító",
    "COPY_SUCCESSFUL": "Vágólapra másolva",
    "COPY_NAME": "Név másolása",
    "COPY_REFERER": "URL másolása",
    "COMPANY": "Cég",
    "LOCATION": "Hely",
    "LTV": "LTV",
    "BROWSER_LANGUAGE": "Böngésző nyelve",
    "CONVERSATION_LANGUAGE": "Beszélgetés nyelve",
    "CONVERSATION_TITLE": "Beszélgetés részletei",
    "VIEW_PROFILE": "Profil megtekintése",
    "BROWSER": "Böngésző",
    "OS": "Operációs rendszer",
    "INITIATED_FROM": "Kezdeményezve",
    "INITIATED_AT": "Kezdeményezve",
    "IP_ADDRESS": "IP cím",
    "CREATED_AT_LABEL": "Létrehozva",
    "NEW_MESSAGE": "Új üzenet",
    "CONVERSATIONS": {
      "NO_RECORDS_FOUND": "Nincs megelőző beszélgetés ezzel a kontakttal.",
      "TITLE": "Korábbi beszélgetések"
    },
    "LABELS": {
      "CONTACT": {
        "TITLE": "Kapcsolattartó címkéi",
        "ERROR": "Nem lehetett frissíteni a címkéket"
      },
      "CONVERSATION": {
        "TITLE": "Beszélgetés cimkék",
        "ADD_BUTTON": "Címkék hozzáadása"
      },
      "LABEL_SELECT": {
        "TITLE": "Címkék hozzáadása",
        "PLACEHOLDER": "Címkék keresése",
        "NO_RESULT": "Nem találtunk címkét",
        "CREATE_LABEL": "Új cimke létrehozása"
      }
    },
    "MERGE_CONTACT": "Kapcsolattartók összevonása",
    "CONTACT_ACTIONS": "Kapcsolattartói tevékenységek",
    "MUTE_CONTACT": "Kontakt blokkolása",
    "MUTE_CONTACT_DISABLED": "Nem használható. A teljes kapcsolattartó domain blokkolva van.",
    "UNMUTE_CONTACT": "Kontakt blokkolásának feloldása",
    "BLOCK_CONTACT_DOMAIN": "Kapcsolattartó domain blokkolása",
    "UNBLOCK_CONTACT_DOMAIN": "Kapcsolattartó domain blokkolásának feloldása",
    "BLOCK_CONTACT_DOMAIN_DISABLED": "Ez a kapcsolattartó domain nem blokkolható.",
    "BLOCK_CONTACT_DOMAIN_MESSAGE": "A domain blokkolása blokkolja az összes jelenlegi és jövőbeli kapcsolattartót az adott domainhez.",
    "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "A domain blokkolásának feloldása eltávolítja a blokkolást az adott domain összes kapcsolattartójáról (beleértve azokat is, amelyek manuálisan voltak blokkolva).",
    "BLOCK_PUBLIC_DOMAIN_TITLE": "Nyilvános email domain",
    "BLOCK_PUBLIC_DOMAIN_MESSAGE": "A(z) {domain} egy nyilvános email domain, amelyet sok, egymással nem kapcsolatban álló feladó használ, ezért nem blokkolható teljes egészében. Szeretné csak ezt a címet ({email}) blokkolni?",
    "BLOCK_ONLY_THIS_ADDRESS": "Csak ennek a címnek a blokkolása",
    "MUTED_SUCCESS": "A kapcsolat sikeresen letiltva. Beszélgetései hamarosan lezárásra kerülnek a háttérben.",
    "UNMUTED_SUCCESS": "A kontakt blokkolása sikeresen feloldva.",
    "OPEN_JARABOT": "AI válaszok előzményeinek megnyitása",
    "TRANSLATE_CONVERSATION": "Beszélgetés fordítása",
    "TRANSLATE_INITIATED": "A fordítás elindult. Hosszabb beszélgetéseknél ez eltarthat egy ideig.",
    "TRANSLATE_SUCCESS": "A beszélgetés fordítása sikeresen befejeződött.",
    "TRANSLATE_ERROR": "Nem sikerült lefordítani a beszélgetést. Kérjük, próbálja újra.",
    "MOVE_CONVERSATION": "Beszélgetés áthelyezése",
    "MOVE_CONVERSATION_MISSING_EMAIL": "A kapcsolattartó e-mail címe szükséges a beszélgetés e-mail postafiókba való áthelyezéséhez",
    "MERGE_CONVERSATION": "Beszélgetés egyesítése",
    "CONTACT_DOMAIN_BLOCKED_SUCCESS": "A domain sikeresen blokkolva lett. Nem kap értesítést a jövőbeli beszélgetésekről.",
    "CONTACT_DOMAIN_UNBLOCKED_SUCCESS": "A domain blokkolása sikeresen feloldva.",
    "SEND_TRANSCRIPT": "Jegyzetek elküldése",
    "EDIT_LABEL": "Szerkesztés",
    "SIDEBAR_SECTIONS": {
      "CUSTOM_ATTRIBUTES": "Egyedi atribútumok",
      "CONTACT_LABELS": "Kontakt címkéi",
      "PREVIOUS_CONVERSATIONS": "Korábbi beszélgetések",
      "NO_RECORDS_FOUND": "Nem található tulajdonság"
    }
  },
  "EDIT_CONTACT": {
    "BUTTON_LABEL": "Jegyzetek szerkesztése",
    "TITLE": "Kontakt szerkesztése",
    "DESC": "Kontakt részletek szerkesztése"
  },
  "DELETE_CONTACT": {
    "BUTTON_LABEL": "Kontakt Törlése",
    "TITLE": "Kontakt törlése",
    "DESC": "Kontakt részletek törlése",
    "CONFIRM": {
      "TITLE": "Törlés megerősítése",
      "MESSAGE": "Biztos abban, hogy törli ",
      "YES": "Igen, Törlés",
      "NO": "Nem, Mégse"
    },
    "API": {
      "SUCCESS_MESSAGE": "Kontakt sikeresen törölve",
      "ERROR_MESSAGE": "A kontakt törlése nem lehetséges. Kérjük próbáld később."
    }
  },
  "CONTACT_FORM": {
    "FORM": {
      "SUBMIT": "Mentés",
      "CANCEL": "Mégse",
      "AVATAR": {
        "LABEL": "Kontakt avatarja"
      },
      "NAME": {
        "PLACEHOLDER": "A kontakt teljes nevének megadása",
        "LABEL": "Teljes név"
      },
      "BIO": {
        "PLACEHOLDER": "A kontakt önéletrajzának megadása",
        "LABEL": "Önéletrajz"
      },
      "EMAIL_ADDRESS": {
        "PLACEHOLDER": "A kontakt e-mailjének megadása",
        "LABEL": "Email cím",
        "DUPLICATE": "Az e-mailcím már egy másik kontakthoz tartozik.",
        "ERROR": "Kérjük helyes e-mailcímet adj meg."
      },
      "PHONE_NUMBER": {
        "PLACEHOLDER": "A kontakt telefonszámának megadása",
        "LABEL": "Telefonszám",
        "HELP": "A telefonszámnak E.164 formátumúnak kell lennie, pl: +[+][országkód][körzetszám][helyi telefonszám]",
        "ERROR": "A telefonszámnak üresnek vagy E.164 formátumúnak kell lennie",
        "DIAL_CODE_ERROR": "Kérlek, válassz egy hívószámot a listából",
        "DUPLICATE": "Ez a telefonszám már egy másik kontakthoz tartozik."
      },
      "LOCATION": {
        "PLACEHOLDER": "A kontakt helyének megadása",
        "LABEL": "Hely"
      },
      "COMPANY_NAME": {
        "PLACEHOLDER": "Cégnév megadása",
        "LABEL": "Cégnév"
      },
      "COUNTRY": {
        "PLACEHOLDER": "Add meg az ország nevét",
        "LABEL": "Ország neve",
        "SELECT_PLACEHOLDER": "Kiválasztás",
        "REMOVE": "Eltávolítás",
        "SELECT_COUNTRY": "Ország választása"
      },
      "CITY": {
        "PLACEHOLDER": "Add meg a város nevét",
        "LABEL": "Város neve"
      },
      "SOCIAL_PROFILES": {
        "FACEBOOK": {
          "PLACEHOLDER": "Facebook felhasználó megadása",
          "LABEL": "Facebook"
        },
        "TWITTER": {
          "PLACEHOLDER": "Twitter felhasználó megadása",
          "LABEL": "Twitter"
        },
        "LINKEDIN": {
          "PLACEHOLDER": "Linkedin usernév hozzáadása",
          "LABEL": "LinkedIn"
        },
        "GITHUB": {
          "PLACEHOLDER": "Github felhasználó megadása",
          "LABEL": "Github"
        }
      },
      "UNSAVED_CHANGES": {
        "TITLE": "Nem mentett változások",
        "DESCRIPTION": "Nem mentett változásai vannak. Szeretné menteni őket bezárás előtt?",
        "CONFIRM": "Mentés",
        "CANCEL": "Elvetés"
      }
    },
    "DELETE_AVATAR": {
      "API": {
        "SUCCESS_MESSAGE": "Kontakt avatar sikeresen törölve",
        "ERROR_MESSAGE": "A kontakt avatar törlése nem lehetséges. Kérjük próbáld később."
      }
    },
    "SUCCESS_MESSAGE": "Kontakt mentés sikeres",
    "ERROR_MESSAGE": "Hiba történt, kérjük próbáld újra"
  },
  "NEW_CONVERSATION": {
    "BUTTON_LABEL": "Beszélgetés megkezdése",
    "TITLE": "Új beszélgetés",
    "DESC": "Kezdjen új beszélgetést egy új üzenet küldésével.",
    "NO_INBOX": "Nem találtam postafiókot, hogy új beszélgetést kezdeményezzek ezzel a kapcsolattal.",
    "FORM": {
      "TO": {
        "LABEL": "Ide"
      },
      "INBOX": {
        "LABEL": "Fiók",
        "PLACEHOLDER": "Beérkező levelek választása",
        "ERROR": "Válassz egy fiókot"
      },
      "SUBJECT": {
        "LABEL": "Tárgy",
        "PLACEHOLDER": "Tárgy",
        "ERROR": "A tárgy nem lehet üres"
      },
      "MESSAGE": {
        "LABEL": "Üzenet",
        "PLACEHOLDER": "Írd ide üzeneted",
        "ERROR": "Az üzenet nem lehet üres"
      },
      "ATTACHMENTS": {
        "SELECT": "Fájlok kiválasztása",
        "HELP_TEXT": "Húzza ide a fájlokat, vagy válassza ki a csatolandó fájlokat"
      },
      "SUBMIT": "Üzenet elküldése",
      "CANCEL": "Mégse",
      "SUCCESS_MESSAGE": "Üzenet elküldve!",
      "GO_TO_CONVERSATION": "Megtekintés",
      "ERROR_MESSAGE": "Nem sikerült az elküldés! Kérjük próbáld később"
    }
  },
  "CONTACTS_PAGE": {
    "LIST": {
      "TABLE_HEADER": {
        "SOCIAL_PROFILES": "Social media profilok"
      }
    }
  },
  "CUSTOM_ATTRIBUTES": {
    "BUTTON": "Speciális attribútum hozzáadása",
    "COPY_SUCCESSFUL": "Vágólapra másolva",
    "SHOW_MORE": "Összes tulajdonság megjelenítése",
    "SHOW_LESS": "Kevesebb tulajdonság megjelenítése",
    "ACTIONS": {
      "COPY": "Attribútum másolása",
      "DELETE": "Attribútum törlése",
      "EDIT": "Attribútum szerkesztése"
    },
    "ADD": {
      "TITLE": "Saját attribútum létrehozása",
      "DESC": "Egyéni információ hozzáadása ehhez a kontakthoz."
    },
    "FORM": {
      "CREATE": "Attribútum hozzáadása",
      "CANCEL": "Mégse",
      "NAME": {
        "LABEL": "Egyedi attribútum név",
        "PLACEHOLDER": "Pl.: shopify id",
        "ERROR": "Érvénytelen egyéni tulajdonság név"
      },
      "VALUE": {
        "LABEL": "Attribútum érték",
        "PLACEHOLDER": "Pl.: 11901 "
      },
      "ADD": {
        "TITLE": "Új tulajdonság  létrehozása",
        "SUCCESS": "Tulajdonság sikeresen hozzáaadva",
        "ERROR": "Nem lehet hozzáadni a tulajdonságot. Kérlek, próbáld újra később"
      },
      "UPDATE": {
        "SUCCESS": "Tulajdonság sikeresen frissítve",
        "ERROR": "Nem lehet frissíteni a tulajdonságot. Kérlek, próbáld újra később"
      },
      "DELETE": {
        "SUCCESS": "Tulajdonság sikeresen törölve",
        "ERROR": "Nem lehet törölni a tulajdonságot. Kérlek, próbáld újra később"
      },
      "ATTRIBUTE_SELECT": {
        "TITLE": "Attribútum hozzáadása",
        "PLACEHOLDER": "Tulajdonságok keresése",
        "NO_RESULT": "Nem található tulajdonság"
      },
      "ATTRIBUTE_TYPE": {
        "LIST": {
          "PLACEHOLDER": "Válassz egyet",
          "SEARCH_INPUT_PLACEHOLDER": "Keress",
          "NO_RESULT": "Nincs találat"
        }
      }
    },
    "VALIDATIONS": {
      "REQUIRED": "Kötelező megadni",
      "INVALID_URL": "Hibás URL",
      "INVALID_INPUT": "Érvénytelen bevitel"
    }
  },
  "MERGE_CONTACTS": {
    "TITLE": "Kontaktok egyesítése",
    "DESCRIPTION": "Merge contacts to combine two profiles into one, including all attributes and conversations. In case of conflict, the Primary contact’ s attributes will take precedence.",
    "PRIMARY": {
      "TITLE": "Elsődleges kontakt",
      "HELP_LABEL": "Törlendő"
    },
    "PARENT": {
      "TITLE": "Egyesítendő kontakt",
      "PLACEHOLDER": "Kontakt keresése",
      "HELP_LABEL": "Megtartani"
    },
    "SUMMARY": {
      "TITLE": "Összegzés",
      "DELETE_WARNING": "<strong>{primaryContactName}</strong> kontaktja törlésre kerül.",
      "ATTRIBUTE_WARNING": "<strong>{primaryContactName}</strong> kontakt adatai át lesznek másolva hozzá: <strong>{parentContactName}</strong>."
    },
    "SEARCH": {
      "ERROR_MESSAGE": "Hiba történt. Kérjük, próbálja újra később."
    },
    "FORM": {
      "SUBMIT": " Kontaktok egyesítése",
      "CANCEL": "Mégse",
      "CHILD_CONTACT": {
        "ERROR": "Válaszd ki a gyerek kontatkot az összevonáshoz"
      },
      "SUCCESS_MESSAGE": "Kontakt összevonása sikeres",
      "ERROR_MESSAGE": "Nem sikerült a kontaktot összevonni, próbáld újra!"
    },
    "DROPDOWN_ITEM": {
      "ID": "(azonosító: {identifier})"
    }
  },
  "CONTACTS_LAYOUT": {
    "HEADER": {
      "TITLE": "Kontaktok",
      "SEARCH_TITLE": "Kontaktok keresése",
      "SEARCH_PLACEHOLDER": "Keresés...",
      "MESSAGE_BUTTON": "Üzenet",
      "SEND_MESSAGE": "Üzenet elküldése",
      "SHOW_DETAILS": "Kapcsolat részletei",
      "BLOCKING": "Blokkolás",
      "BLOCK_CONTACT": "Kontakt blokkolása",
      "UNBLOCK_CONTACT": "Blokkolás feloldása",
      "BLOCK_CONTACT_MESSAGE": "Ennek a kapcsolattartónak a blokkolása megakadályozza, hogy új beszélgetéseket hozzon létre, és az összes meglévő beszélgetése lezárul. Biztosan blokkolni szeretné ezt a kapcsolattartót?",
      "UNBLOCK_CONTACT_MESSAGE": "A kapcsolattartó blokkolásának feloldása lehetővé teszi számára új beszélgetések létrehozását. Biztosan feloldja a blokkolást?",
      "BLOCK_CONTACT_DISABLED": "Nem használható. A teljes kapcsolattartó domain blokkolva van.",
      "BLOCK_CONTACT_DOMAIN": "Kapcsolattartó domain blokkolása",
      "UNBLOCK_CONTACT_DOMAIN": "Kapcsolattartó domain blokkolásának feloldása",
      "BLOCK_CONTACT_DOMAIN_DISABLED": "Ez a kapcsolattartó domain nem blokkolható.",
      "BLOCK_CONTACT_DOMAIN_MESSAGE": "A domain blokkolása blokkolja az összes jelenlegi és jövőbeli kapcsolattartót az adott domainhez.",
      "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "A domain blokkolásának feloldása eltávolítja a blokkolást az adott domain összes kapcsolattartójáról (beleértve azokat is, amelyek manuálisan voltak blokkolva).",
      "BLOCK_PUBLIC_DOMAIN_TITLE": "Nyilvános email domain",
      "BLOCK_PUBLIC_DOMAIN_MESSAGE": "A(z) {domain} egy nyilvános email domain, amelyet sok, egymással nem kapcsolatban álló feladó használ, ezért nem blokkolható teljes egészében. Szeretné csak ezt a kapcsolattartót ({email}) blokkolni?",
      "BLOCK_ONLY_THIS_CONTACT": "Csak ennek a kapcsolattartónak a blokkolása",
      "DIAL": "Tárcsázás",
      "BREADCRUMB": {
        "CONTACTS": "Kontaktok"
      },
      "ACTIONS": {
        "CONTACT_CREATION": {
          "ADD_CONTACT": "Kontakt hozzáadása",
          "EXPORT_CONTACT": "Kontaktok exportálása",
          "IMPORT_CONTACT": "Kontaktok importálása",
          "SAVE_CONTACT": "Kontakt mentése",
          "EMAIL_ADDRESS_DUPLICATE": "Az e-mailcím már egy másik kontakthoz tartozik.",
          "PHONE_NUMBER_DUPLICATE": "Ez a telefonszám már egy másik kontakthoz tartozik.",
          "SUCCESS_MESSAGE": "Kontakt mentés sikeres",
          "ERROR_MESSAGE": "A kontakt mentése nem sikerült. Kérjük, próbálja újra később."
        },
        "BLOCK_SUCCESS_MESSAGE": "A kapcsolat sikeresen letiltva. Beszélgetései hamarosan lezárásra kerülnek a háttérben.",
        "BLOCK_ERROR_MESSAGE": "A kontakt blokkolása nem sikerült. Kérjük, próbálja újra később.",
        "UNBLOCK_SUCCESS_MESSAGE": "A kontakt blokkolása sikeresen feloldva",
        "UNBLOCK_ERROR_MESSAGE": "A kontakt blokkolásának feloldása nem sikerült. Kérjük, próbálja újra később.",
        "IMPORT_CONTACT": {
          "TITLE": "Kontaktok importálása",
          "DESCRIPTION": "Kontaktok importálása CSV fájlból.",
          "DOWNLOAD_LABEL": "Minta CSV fájl letöltése.",
          "LABEL": "CSV fájl:",
          "CHOOSE_FILE": "Fájl kiválasztása",
          "CHANGE": "Megváltoztatás",
          "CANCEL": "Mégse",
          "IMPORT": "Importálás",
          "SUCCESS_MESSAGE": "Értesítjük emailben, amint a befogadás megtörtént.",
          "ERROR_MESSAGE": "Hiba történt, kérjük próbáld újra"
        },
        "EXPORT_CONTACT": {
          "TITLE": "Kontaktok exportálása",
          "DESCRIPTION": "Exportáljon gyorsan egy CSV fájlt a kontaktok részletes adataival",
          "CONFIRM": "Exportálás",
          "SUCCESS_MESSAGE": "Export is in progress, You will be notified via email when export file is ready to dowanlod.",
          "ERROR_MESSAGE": "Hiba történt, kérjük próbáld újra"
        },
        "SORT_BY": {
          "LABEL": "Rendezés",
          "OPTIONS": {
            "NAME": "Név",
            "EMAIL": "E-mail",
            "PHONE_NUMBER": "Telefonszám",
            "COMPANY": "Cég",
            "COUNTRY": "Ország",
            "CITY": "Város",
            "LAST_ACTIVITY": "Utolsó aktivitás",
            "CREATED_AT": "Létrehozva"
          }
        },
        "ORDER": {
          "LABEL": "Sorrend",
          "OPTIONS": {
            "ASCENDING": "Növekvő",
            "DESCENDING": "Csökkenő"
          }
        },
        "FILTERS": {
          "CREATE_SEGMENT": {
            "TITLE": "El akarod menteni ezt a szűrőt?",
            "CONFIRM": "Szűrő mentése",
            "LABEL": "Név",
            "PLACEHOLDER": "Adja meg a szűrő nevét",
            "ERROR": "Adjon meg érvényes nevet",
            "SUCCESS_MESSAGE": "A szűrő sikeresen mentve",
            "ERROR_MESSAGE": "A szűrő mentése nem sikerült. Kérjük, próbálja újra később."
          },
          "DELETE_SEGMENT": {
            "TITLE": "Törlés megerősítése",
            "DESCRIPTION": "Biztosan törli ezt a szűrőt?",
            "CONFIRM": "Igen, Törlés",
            "CANCEL": "Nem, mégse",
            "SUCCESS_MESSAGE": "A szűrő sikeresen törölve",
            "ERROR_MESSAGE": "A szűrő törlése nem sikerült. Kérjük, próbálja újra később."
          }
        }
      }
    },
    "PAGINATION_FOOTER": {
      "SHOWING": "{startItem} - {endItem} / {totalItems} kontakt"
    },
    "FILTER": {
      "NAME": "Név",
      "EMAIL": "E-mail",
      "PHONE_NUMBER": "Telefonszám",
      "IDENTIFIER": "Azonosító",
      "COUNTRY": "Ország",
      "CITY": "Város",
      "CREATED_AT": "Létrehozva",
      "LAST_ACTIVITY": "Utolsó aktivitás",
      "REFERER_LINK": "Hivatkozás link",
      "BLOCKED": "Blokkolt",
      "BLOCKED_TRUE": "Igaz",
      "BLOCKED_FALSE": "Hamis",
      "BUTTONS": {
        "CLEAR_FILTERS": "Szűrők törlése",
        "UPDATE_SEGMENT": "Szegmens frissítése",
        "APPLY_FILTERS": "Szűrők alkalmazása",
        "ADD_FILTER": "Szűrő hozzáadása"
      },
      "TITLE": "Kontaktok szűrése",
      "EDIT_SEGMENT": "Szegmens szerkesztése",
      "SEGMENT": {
        "LABEL": "Szegmens neve",
        "INPUT_PLACEHOLDER": "Adja meg a szegmens nevét"
      },
      "ACTIVE_FILTERS": {
        "MORE_FILTERS": "+ {count} további szűrő",
        "CLEAR_FILTERS": "Szűrők törlése"
      }
    },
    "CARD": {
      "OF": "/",
      "VIEW_DETAILS": "Részletek megtekintése",
      "EDIT_DETAILS_FORM": {
        "TITLE": "Kontakt részletek szerkesztése",
        "FORM": {
          "FIRST_NAME": {
            "PLACEHOLDER": "Adja meg a keresztnevet",
            "ERROR": "A keresztnév megadása kötelező."
          },
          "LAST_NAME": {
            "PLACEHOLDER": "Adja meg a vezetéknevet"
          },
          "EMAIL_ADDRESS": {
            "PLACEHOLDER": "Adja meg az e-mail-címet",
            "DUPLICATE": "Az e-mailcím már egy másik kontakthoz tartozik.",
            "ERROR": "Kérjük helyes e-mailcímet adj meg."
          },
          "PHONE_NUMBER": {
            "PLACEHOLDER": "Adja meg a telefonszámot",
            "DUPLICATE": "Ez a telefonszám már egy másik kontakthoz tartozik."
          },
          "CITY": {
            "PLACEHOLDER": "Add meg a város nevét"
          },
          "COUNTRY": {
            "PLACEHOLDER": "Válasszon országot"
          },
          "BIO": {
            "PLACEHOLDER": "Adja meg a bemutatkozást"
          },
          "COMPANY_NAME": {
            "PLACEHOLDER": "Cégnév megadása"
          }
        },
        "UPDATE_BUTTON": "Kontakt frissítése",
        "SUCCESS_MESSAGE": "A kontakt sikeresen frissítve",
        "ERROR_MESSAGE": "A kontakt frissítése nem sikerült. Kérjük, próbálja újra később."
      },
      "SOCIAL_MEDIA": {
        "TITLE": "Közösségi linkek szerkesztése",
        "FORM": {
          "FACEBOOK": {
            "PLACEHOLDER": "Facebook hozzáadása"
          },
          "GITHUB": {
            "PLACEHOLDER": "Github hozzáadása"
          },
          "INSTAGRAM": {
            "PLACEHOLDER": "Instagram hozzáadása"
          },
          "WHATSAPP": {
            "PLACEHOLDER": "WhatsApp hozzáadása"
          },
          "LINKEDIN": {
            "PLACEHOLDER": "LinkedIn hozzáadása"
          },
          "TWITTER": {
            "PLACEHOLDER": "Twitter hozzáadása"
          }
        }
      }
    },
    "DETAILS": {
      "CREATED_AT": "Létrehozva: {date}",
      "LAST_ACTIVITY": "Utoljára aktív: {date}",
      "DELETE_CONTACT_DESCRIPTION": "A kontakt végleges törlése. Ez a művelet nem vonható vissza",
      "DELETE_CONTACT": "Kontakt törlése",
      "DELETE_DIALOG": {
        "TITLE": "Törlés megerősítése",
        "DESCRIPTION": "Biztosan törli ezt a kontaktot: {contactName}?",
        "CONFIRM": "Igen, Törlés",
        "API": {
          "SUCCESS_MESSAGE": "Kontakt sikeresen törölve",
          "ERROR_MESSAGE": "A kontakt törlése nem lehetséges. Kérjük próbáld később."
        }
      },
      "AVATAR": {
        "UPLOAD": {
          "ERROR_MESSAGE": "Az avatar feltöltése nem sikerült. Kérjük, próbálja újra később.",
          "SUCCESS_MESSAGE": "Az avatar sikeresen feltöltve"
        },
        "DELETE": {
          "SUCCESS_MESSAGE": "Avatar sikeresen törölve",
          "ERROR_MESSAGE": "Az avatar törlése nem sikerült. Kérjük, próbálja újra később."
        }
      }
    },
    "SIDEBAR": {
      "TABS": {
        "ATTRIBUTES": "Attribútumok",
        "HISTORY": "History",
        "NOTES": "Megjegyzések",
        "MERGE": "Egyesítés",
        "ORDER_HISTORY": "Legutóbbi rendelések",
        "RETINO": "Retino"
      },
      "HISTORY": {
        "EMPTY_STATE": "Nincs megelőző beszélgetés ezzel a kontakttal"
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "Tulajdonságok keresése",
        "UNUSED_ATTRIBUTES": "{count} nem használt tulajdonság",
        "EMPTY_STATE": "Ebben a fiókban nincs elérhető egyéni kontakt tulajdonság. Egyéni tulajdonságot a beállításokban hozhat létre.",
        "YES": "Igen",
        "NO": "Nem",
        "TRIGGER": {
          "SELECT": "Válassz egyet",
          "INPUT": "Adja meg az értéket"
        },
        "VALIDATIONS": {
          "INVALID_NUMBER": "Érvénytelen szám",
          "REQUIRED": "Kötelező megadni",
          "INVALID_INPUT": "Érvénytelen bevitel",
          "INVALID_URL": "Hibás URL",
          "INVALID_DATE": "Érvénytelen dátum"
        },
        "NO_ATTRIBUTES": "Nem található tulajdonság",
        "API": {
          "SUCCESS_MESSAGE": "Tulajdonság sikeresen frissítve",
          "DELETE_SUCCESS_MESSAGE": "Tulajdonság sikeresen törölve",
          "UPDATE_ERROR": "Nem lehet frissíteni a tulajdonságot. Kérlek, próbáld újra később",
          "DELETE_ERROR": "Nem lehet törölni a tulajdonságot. Kérlek, próbáld újra később"
        }
      },
      "MERGE": {
        "TITLE": "Kapcsolattartók összevonása",
        "DESCRIPTION": "Két profil egyesítése egybe, az összes tulajdonsággal és beszélgetéssel együtt. Ütközés esetén az elsődleges kontakt tulajdonságai érvényesek.",
        "PRIMARY": "Elsődleges kontakt",
        "PRIMARY_HELP_LABEL": "Megmarad",
        "PRIMARY_REQUIRED_ERROR": "A folytatás előtt válassza ki, melyik kontakttal egyesít",
        "PARENT": "Egyesítésre kerül",
        "PARENT_HELP_LABEL": "Törlendő",
        "EMPTY_STATE": "Nincs találat a kontaktok között",
        "PLACEHOLDER": "Elsődleges kontakt keresése",
        "SEARCH_PLACEHOLDER": "Kontakt keresése",
        "SEARCH_ERROR_MESSAGE": "A kontaktok keresése nem sikerült. Kérjük, próbálja újra később.",
        "SUCCESS_MESSAGE": "Kontakt összevonása sikeres",
        "ERROR_MESSAGE": "Nem sikerült a kontaktot összevonni, próbáld újra!",
        "IS_SEARCHING": "Keresés...",
        "BUTTONS": {
          "CANCEL": "Mégse",
          "CONFIRM": "Kapcsolattartók összevonása"
        }
      },
      "NOTES": {
        "PLACEHOLDER": "Megjegyzés hozzáadása",
        "WROTE": "írta",
        "YOU": "Ön",
        "SAVE": "Jegyzet mentése",
        "EMPTY_STATE": "Ehhez a kontakthoz nem tartozik jegyzet. Jegyzetet a fenti mezőbe írva adhat hozzá."
      }
    },
    "EMPTY_STATE": {
      "TITLE": "Ebben a fiókban nincs kontakt",
      "SUBTITLE": "Új kontaktok hozzáadásához kattintson az alábbi gombra",
      "BUTTON_LABEL": "Kontakt hozzáadása",
      "SEARCH_EMPTY_STATE_TITLE": "Nincs a keresésnek megfelelő kontakt 🔍",
      "LIST_EMPTY_STATE_TITLE": "Ebben a nézetben nincs kontakt 📋"
    }
  },
  "COMPOSE_NEW_CONVERSATION": {
    "TITLE": "Új beszélgetés",
    "CONTACT_SEARCH": {
      "ERROR_MESSAGE": "We couldn’t complete the search. Please try again."
    },
    "FORM": {
      "GO_TO_CONVERSATION": "Megtekintés",
      "SUCCESS_MESSAGE": "Az üzenet sikeresen elküldve!",
      "ERROR_MESSAGE": "Hiba történt a beszélgetés létrehozásakor. Kérjük, próbálja újra később.",
      "NO_INBOX_ALERT": "Nincs elérhető postafiók, amelyből beszélgetést indíthatna ezzel a kontakttal.",
      "CONTACT_SELECTOR": {
        "LABEL": "Ide:",
        "TAG_INPUT_PLACEHOLDER": "Kontakt keresése név, e-mail-cím vagy telefonszám alapján",
        "CONTACT_CREATING": "Kontakt létrehozása..."
      },
      "INBOX_SELECTOR": {
        "LABEL": "Postafiók:",
        "BUTTON": "Postafiókok megjelenítése"
      },
      "EMAIL_OPTIONS": {
        "SUBJECT_LABEL": "Tárgy :",
        "SUBJECT_PLACEHOLDER": "Adja meg az e-mail tárgyát",
        "CC_LABEL": "Másolat:",
        "CC_PLACEHOLDER": "Kontakt keresése e-mail-cím alapján",
        "BCC_LABEL": "Titkos másolat:",
        "BCC_PLACEHOLDER": "Kontakt keresése e-mail-cím alapján",
        "BCC_BUTTON": "Titkos másolat"
      },
      "MESSAGE_EDITOR": {
        "PLACEHOLDER": "Írd ide üzeneted..."
      },
      "WHATSAPP_OPTIONS": {
        "LABEL": "Sablon kiválasztása",
        "SEARCH_PLACEHOLDER": "Sablonok keresése",
        "EMPTY_STATE": "Nincs találat a sablonok között",
        "TEMPLATE_PARSER": {
          "TEMPLATE_NAME": "WhatsApp sablon: {templateName}",
          "VARIABLES": "Változók",
          "BACK": "Visszaugrás",
          "SEND_MESSAGE": "Üzenet elküldése"
        }
      },
      "ACTION_BUTTONS": {
        "DISCARD": "Discard",
        "SEND": "Küldés ({keyCode})",
        "MARK_RESOLVED": "Az új beszélgetés megjelölése lezártként küldés után",
        "SAVE_DRAFT": "Piszkozat mentése",
        "CREATE_AS_INTERNAL": "Létrehozás jegyzettel ellátott beszélgetésként",
        "SEND_AND_RESOLVE_ORIGINAL": "Küldés és az eredeti beszélgetés lezárása ({keyCode})"
      },
      "DISCARD": "Piszkozat elvetése",
      "DISCARD_MODAL": {
        "TITLE": "Piszkozat elvetése",
        "DESCRIPTION": "Biztosan el szeretné vetni ezt a piszkozatot?",
        "CONFIRM": "Igen, elvetés",
        "CANCEL": "Nem, megtartás"
      }
    }
  }
}
